module.exports = __webpack_public_path__ + "img/img5.25dfe7d7.png";